import { Routes } from "@angular/router";
import { WorkflowPartnerAiTariffComponent } from "./workflow-partner-ai-tariff.component";

export const workflowPartnerAiTariffRouting: Routes = [
    { path: 'partner/change-ai-tariff/:aid', component: WorkflowPartnerAiTariffComponent, children: [
        { path: 'choose-ai-tariff', component: WorkflowPartnerAiTariffComponent, data: { step: 'choose-ai-tariff' } },
        { path: 'delivery-date', component: WorkflowPartnerAiTariffComponent, data: { step: 'delivery-date' } },
        { path: 'contact', component: WorkflowPartnerAiTariffComponent, data: { step: 'contact' } },
        { path: 'invoice-address', component: WorkflowPartnerAiTariffComponent, data: { step: 'invoice-address' } },
        { path: 'payment', component: WorkflowPartnerAiTariffComponent, data: { step: 'payment-method' } },
        { path: 'checkout-summary', component: WorkflowPartnerAiTariffComponent, data: { step: 'checkout-summary' } },
        { path: 'complete', component: WorkflowPartnerAiTariffComponent, data: { step: 'complete' } },
        { path: '', redirectTo: 'choose-ai-tariff', pathMatch: 'full' },
    ]},
]